const getSortOptionStateClasses = (selected: boolean): string =>
  selected
    ? 'bg-blue-10 hover:bg-blue-30 font-semibold'
    : 'hover:bg-neutral-10';

export default getSortOptionStateClasses;
